import { Routes, Route, Navigate } from 'react-router-dom';
import PaymentPage from '../pages/Payment/PaymentPage';
import PaymentCallbackPage from '../pages/PaymentCallback/PaymentCallbackPage';

const AppRouter = () => (
  <Routes>
    <Route path="/" element={<Navigate to="/payment" />} />
    <Route path="/payment" element={<PaymentPage />} />
    <Route path="/payment/callback" element={<PaymentCallbackPage />} />
  </Routes>
);

export default AppRouter;
